import {MessageService} from 'primeng/api';
import {
  Component,
  OnInit,
  Input,
  HostListener,
  ElementRef,
} from '@angular/core';
import {HelpersService} from '../../../services/helpers.service';
import {PartnerService} from '../../../services/partner.service';
import {ServiceTypeService} from '../../../services/service-type.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router, ActivatedRoute} from '@angular/router';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {ConfirmationService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {DialogModule} from 'primeng/dialog';

@Component({
  selector: 'app-shared-service',
  templateUrl: './shared-service.component.html',
  styleUrls: ['./shared-service.component.scss'],
  providers: [MessageService],
})
export class SharedServiceComponent implements OnInit {
  @Input() vatInclusive;
  //@Input() messageService: MessageService;
  @Input() currencySymbol;
  @Input() Categories;
  @Input() isPortal;
  @Input() isCollections;
  @Input() categoryView;
  @Input() searchService;
  @Input() setCategories;
  @Input() technicians;

  public serviceTypes: any = [];
  public loading = true;
  public category = '';
  public open = 'all';
  public allServiceTypes: any = [];
  public option = '';
  public editCategory = -1;
  public maxHeight = 500;
  categoryEditing: any;
  collapsedCategories: any = [];
  public showServiceType: boolean = false;
  public selectedServiceType: any = {};
  public groupOrder: any = [];
  public showFittings = false;
  public globalSelectValue: any;
  public busyBulkActioning: boolean = false;
  public linkedPartners: any = [];
  public showBulkCopyDialog: boolean = false;
  public errorLoadingServerTypes: boolean = false;
  public selectedPartners: any = [];

  constructor(
    private partnerService: PartnerService,
    public helpersService: HelpersService,
    public modalService: NgbModal,
    private eRef: ElementRef,
    public router: Router,
    public messageService: MessageService,
    public route: ActivatedRoute,
    public serviceTypeService: ServiceTypeService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.loading = true;

    if (this.route.snapshot.routeConfig.path === 'fittings') {
      this.showFittings = true;
    }

    this.getLinkedStores();
    this.getServiceTypes();
  }

  ngOnChanges(changes) {
    if (changes.searchService) {
      this.search(changes.searchService.currentValue);
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    this.option = '';
  }

  setEditCategory(i) {
    this.Categories[i].editing = true;
    this.categoryEditing = this.Categories[i].name;
  }

  setOption(name) {
    setTimeout(() => {
      this.option = name;
    }, 10);
  }

  setOpen(category) {
    this.open = this.open === category ? '' : category;
  }

  search(search) {
    this.open = 'all';
    this.Categories = [];
    let temp = {};
    this.allServiceTypes.forEach((element) => {
      if (element.IsActive) {
        const hoursFloored = Math.floor(element.Hours);
        element.displayTime =
          (hoursFloored ? `${hoursFloored}h` : ``) +
          (element.Hours > hoursFloored
            ? ` ${Math.round((element.Hours - hoursFloored) * 60)}min`
            : ``);
        if (
          search === '' ||
          element.ServiceTypeDescription.toLowerCase().includes(
            search.toLowerCase(),
          )
        ) {
          if (temp[element.GroupName]) {
            temp[element.GroupName].push(element);
          } else {
            temp[element.GroupName] = [element];
          }
          if (this.Categories.find((x) => x.name === element.GroupName)) {
            this.Categories = this.Categories.map((x) => {
              if (x.name === element.GroupName) {
                x.deletable = false;
              }
              return x;
            });
          } else {
            this.Categories.push({
              name: element.GroupName,
              color: '#' + this.intToRGB(this.hashCode(element.GroupName)),
              deletable: false,
            });
          }
        }
      }
    });
    this.serviceTypes = temp;
  }

  addCategory() {
    if (this.category !== '') {
      this.Categories.push({
        name: this.category,
        color: '#' + Math.floor(Math.random() * 16777215).toString(16),
        deletable: true,
      });
      this.category = '';
    }
  }

  deleteCategory(category) {
    if (!this.serviceTypes[category]) {
      this.Categories = this.Categories.filter((x) => x.name !== category);
    } else {
      this.setOpen(category);
    }
  }

  hashCode(str) {
    var hash = 0;
    if (str) {
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
    }
    return hash;
  }

  intToRGB(i) {
    var c = (i & 0x00ffffff).toString(16).toUpperCase();
    return '00000'.substring(0, 6 - c.length) + c;
  }

  getServiceTypes() {
    this.partnerService
      .getPartnerServiceTypesFull(
        this.helpersService.getPartnerId(),
        this.showFittings,
      )
      .subscribe(
        (serviceTypes) => {
          this.Categories = [];
          serviceTypes = serviceTypes.sort((a, b) => {
            if (a.GroupOrder < b.GroupOrder) {
              return -1;
            } else if (a.GroupOrder > b.GroupOrder) {
              return 1;
            } else {
              return 0;
            }
          });
          this.allServiceTypes = serviceTypes;
          let temp = {};
          serviceTypes.forEach((element) => {
            if (element.IsActive) {
              const hoursFloored = Math.floor(element.Hours);
              element.displayTime =
                (hoursFloored ? `${hoursFloored}h` : ``) +
                (element.Hours > hoursFloored
                  ? ` ${Math.round((element.Hours - hoursFloored) * 60)}min`
                  : ``);
              if (temp[element.GroupName]) {
                temp[element.GroupName].push(element);
              } else {
                temp[element.GroupName] = [element];
              }
              if (this.Categories.find((x) => x.name === element.GroupName)) {
                this.Categories = this.Categories.map((x) => {
                  if (x.name === element.GroupName) {
                    x.deletable = false;
                  }
                  return x;
                });
              } else if (!this.isCollections) {
                this.Categories.push({
                  name: element.GroupName,
                  order: element.GroupOrder,
                  color: '#' + this.intToRGB(this.hashCode(element.GroupName)),
                  deletable: false,
                });
              }
            }
          });
          this.serviceTypes = temp;
          this.setCategories(this.Categories);
          this.loading = false;
          this.busyBulkActioning = false;
          this.errorLoadingServerTypes = false;
        },
        (err) => {
          this.loading = false;
          this.errorLoadingServerTypes = true;
          this.busyBulkActioning = false;
          this.serviceTypes = [];
          this.setCategories([]);
        },
      );
  }

  changeCategoryName(i) {
    if (this.Categories[i].name === '') {
      this.Categories[i].editing = false;
      this.Categories[i].name = this.categoryEditing;
    } else {
      this.Categories[i].editing = false;
      const key = Object.keys(this.serviceTypes)[i];

      const categories = {
        Services: this.serviceTypes[key].map((x) => x.ID),
        CategoryName: this.categoryEditing,
      };
      this.partnerService.setServiceCategory(categories).subscribe((res) => {
        this.Categories = [];
        this.getServiceTypes();
      });
    }
  }

  addServiceType(category) {
    this.selectedServiceType = { GroupName: category, Show: true, Hours: 1 };
    this.showServiceType = true;
  }

  editServiceType(serviceType) {
    this.showServiceType = true;
    this.selectedServiceType = serviceType;
  }

  collapseCategory(name) {
    if (this.collapsedCategories.includes(name)) {
      this.collapsedCategories = this.collapsedCategories.filter(
        (x) => x !== name,
      );
    } else {
      this.collapsedCategories.push(name);
    }
  }

  closeSidePanel() {
    this.showServiceType = false;
    this.getServiceTypes();
  }

  drop(event: CdkDragDrop<string[]>) {
    this.arrayMove(this.Categories, event.previousIndex, event.currentIndex);
    this.partnerService
      .updateServiceTypeGroupOrder(
        this.helpersService.getPartnerId(),
        this.Categories.map((x) => {
          return x.name;
        }),
      )
      .subscribe((res) => {
        this.getServiceTypes();
      });
  }

  arrayMove(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  isServiceTypesSelected() {
    var isSelected = false;

    this.Categories.forEach((category) => {
      if (this.serviceTypes[category.name]) {
        this.serviceTypes[category.name].forEach((x) => {
          if (x.selected) isSelected = true;
        });
      }
    });
    return isSelected;
  }

  globalSelected(event) {
    if (event.checked) {
      this.Categories.forEach(category => {
        this.serviceTypes[category.name].forEach((x) => {
          x.selected = true;
        });
      });
    } else {
      this.Categories.forEach(category => {
        this.serviceTypes[category.name].forEach((x) => {
          x.selected = false;
        });
      });
    }
  }


  bulkCopy() {
    this.showBulkCopyDialog = true;
  }

  startBulkCopy(){
    this.busyBulkActioning = true;
    var data = {
      PartnerIDs: this.selectedPartners,
      ServiceTypeIDs: this.getSelectedServiceTypes()
    }
    this.serviceTypeService.bulkCopyServiceTypes(this.helpersService.getPartnerId(), data).subscribe(res => {
      this.getServiceTypes();
      this.globalSelectValue = false;
      this.showBulkCopyDialog = false;
      this.selectedPartners = [];
      this.messageService.add({
        detail: this.translate.instant("bikeshop.service_types.bulk_copy_completed"),
        key: "bottom-center"
     })
    }, err => {
      this.busyBulkActioning = false;
      this.showBulkCopyDialog = false;
    });
  }


  bulkDelete() {
    this.confirmationService.confirm({
      icon: '',
      header: this.translate.instant('bikeshop.service_types.bulk_delete'),
      acceptLabel: this.translate.instant("bikeshop.general.delete"),
      rejectLabel: this.translate.instant("general.cancel"),
      rejectButtonStyleClass: 'alternate',
      message:
        this.translate.instant("bikeshop.service_types.bulk_delete_confirmation"),
      accept: () => {
        this.busyBulkActioning = true;
        var data = {
          ClearAllServiceTypes: this.globalSelectValue,
          ServiceTypeIDs: this.getSelectedServiceTypes(),
          IsFittings: this.showFittings
        }
        this.serviceTypeService.bulkDeleteServiceTypes(this.helpersService.getPartnerId(), data).subscribe(res => {
          this.getServiceTypes();
          this.globalSelectValue = false;
          this.messageService.add({
             detail: this.translate.instant("bikeshop.service_types.bulk_delete_completed"),
             key: "bottom-center"
          })
        }, err => {
          this.busyBulkActioning = false;
        })

      },
    });
  }

  bulkDeleteAll(){
    this.confirmationService.confirm({
      icon: '',
      header: this.translate.instant('bikeshop.service_types.bulk_delete'),
      acceptLabel: this.translate.instant("bikeshop.general.delete"),
      rejectLabel: this.translate.instant("general.cancel"),
      rejectButtonStyleClass: 'alternate',
      message:
        this.translate.instant("bikeshop.service_types.bulk_delete_all_confirmation"),
      accept: () => {
        this.busyBulkActioning = true;
        var data = {
          ClearAllServiceTypes: true,
          ServiceTypeIDs: [],
          IsFittings: this.showFittings
        }
        this.serviceTypeService.bulkDeleteServiceTypes(this.helpersService.getPartnerId(), data).subscribe(res => {
          this.getServiceTypes();
          this.globalSelectValue = false;
          this.messageService.add({
             detail: this.translate.instant("bikeshop.service_types.bulk_delete_completed"),
             key: "bottom-center"
          })
        }, err => {
          this.busyBulkActioning = false;
        })

      },
    });
  }

  getSelectedServiceTypes() {
    var selected: any = [];
    this.Categories.forEach(category => {
      this.serviceTypes[category.name].forEach((x) => {
        if (x.selected) {
          selected.push(x.ID)
        }
      });
    });
    return selected;
  }

  getLinkedStores() {
    this.partnerService.getAllLinkedPartners(this.helpersService.getPartnerId()).subscribe(res => {
      this.linkedPartners = res;
    });
  }
}
